import Link from "next/link";
import React, { useState } from "react";
import News_item from "../../components/blog/news_item";
import { db, app } from "../../firebase/clientApp";
import { Timestamp, collection, getDocs, query, where } from "firebase/firestore";
import { Head } from "../../components/Head";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
import cheerio from 'cheerio';
import { NextPage } from "next";
import Layout from "components/Layout";

interface BlogData {
  title: string;
  image: string;
  author: string;
  content: string;
  readtime: string;
  date: number;
  category: string;
  id: string;
}

const IndexPage: NextPage = () => {
  const [loadMoreBtn, setLoadMoreBtn] = useState(true);
  const [blogsFetched, setBlogsFetched] = useState(false);
  const [pinnedBlogs, setPinnedBlogs] = useState<BlogData[]>([]);
  const [unPinnedBlogs, setUnPinnedBlogs] = useState<BlogData[]>([]);

  const handleLoadMore = () => {
    setLoadMoreBtn(false);
  };
  if (!blogsFetched) {
    const blogItemsRef = collection(db, "BlogItems");

    // Query the collection to retrieve only pinned blog posts
    const q = query(blogItemsRef, where("pinned", "==", true));

    getDocs(q)
      .then((querySnapshot) => {
        // Go through each document
        const newBlogs: BlogData[]  = [];
        querySnapshot.forEach((doc) => {
          const { id, ...docData } = doc.data() as BlogData;
          console.log(
            `DocID:${doc.id} unPinnedBlogs.length ${newBlogs.length}`
          );
          newBlogs.push({ id: doc.id, ...docData  });
        });
        
        setUnPinnedBlogs(newBlogs);
      })
      .catch((error) => {
      });

    // Query the collection to retrieve all unpinned blog posts
    const u = query(blogItemsRef, where("pinned", "==", false));

    getDocs(u)
      .then((querySnapshot) => {
        // Go through each document
        const newBlogs: BlogData[] = [];
        querySnapshot.forEach((doc) => {
          console.log(
          );
          const { id, ...docData } = doc.data() as BlogData;
          newBlogs.push({ id: doc.id, ...docData });
        });
        setUnPinnedBlogs(newBlogs);
      })
      .catch((error) => {
        console.error("Error getting documents: ", error);
      });
    setBlogsFetched(true);
  }

  function getDate(timestamp: number) {
    const date = new Date(timestamp * 1000);
    const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  function getShortDesc(richText:string) {
    if (richText) {
      const $ = cheerio.load(richText);
      const plainText = $.text().trim();
      return `${plainText.substring(0, 120)}...`;
    } else {
      return "";
    }
  }

  return (
    <>
      <Head title="Blogs || DiJT" />
      <Layout>
        {/* <!-- Blog --> */}
      <section className="relative mt-4">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          {/* <!-- Featured Post --> */}
          {blogsFetched && (
            <Swiper
              spaceBetween={0}
              effect={"fade"}
              navigation={true}
              modules={[Autoplay, EffectFade]}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              className="mySwiper max-w-[100%]"
            >
              {pinnedBlogs.map((item) => {
                const {
                  title,
                  image,
                  author,
                  content,
                  readtime,
                  date,
                  category,
                  id,
                } = item;
                console.log(item);
                return (
                  <SwiperSlide key={id}>
                    <article className="mb-[1.875rem] md:mb-16">
                      <div className="rounded-2xl flex flex-col overflow-hidden transition-shadow hover:shadow-lg md:flex-row">
                        <figure className="group overflow-hidden md:w-1/2">
                          <Link href={`/single_post/${id}`}>
                              <img
                                src={image}
                                alt={`pinned ${id}`}
                                className="h-full w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                              />
                          </Link>
                        </figure>

                        {/* <!-- Body --> */}
                        <div className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border bg-white p-[5%] md:w-1/2 md:rounded-none md:rounded-r-[1.25rem]">
                          {/* <!-- Meta --> */}
                          <div className="mb-3 flex flex-wrap items-center space-x-1 text-xs">
                            <Link href={`/single_post/${id}`}>
                              <div className="dark:text-jacarta-200 text-jacarta-700 hover:text-accent">
                                {author}
                              </div>
                            </Link>
                            <span className="dark:text-jacarta-400">in</span>
                            <span className="text-accent inline-flex flex-wrap items-center space-x-1">
                              <Link href={`/single_post/${id}`}>{category}</Link>
                            </span>
                          </div>

                          <h2 className="font-display text-jacarta-700 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white sm:text-3xl">
                            <Link href={`/single_post/${id}`}>
                              <div>{title}</div>
                            </Link>
                          </h2>
                          <p className="dark:text-jacarta-200 mb-8">
                            {getShortDesc(content)}
                          </p>

                          {/* <!-- Date / Time --> */}
                          <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
                            <span>
                              <time>{getDate(date/1000)}</time>
                            </span>
                            <span>•</span>
                            <span>{readtime}</span>
                          </div>
                        </div>
                      </div>
                    </article>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
         <News_item data={unPinnedBlogs.sort((a, b) => b.date - a.date)} />


          {/* <!-- Load More --> */}
          {loadMoreBtn && (
            <div className="mt-10 text-center">
              <button
                onClick={handleLoadMore}
                className="bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </section>
      {/* <!-- end blog --> */}
      </Layout>
      
    </>
  );
};

export default IndexPage;
